import { call, put, takeLatest } from 'redux-saga/effects';

import { Ingestion } from '@models/Ingestion';
import { IngestionApi } from '@apis/IngestionApi';
import { SagaPayload } from '@utils/typescript';
import { Pagination } from '@models/Pagination';

import {
  ingestionsFetch,
  IngestionsFetchPayload,
  ingestionCreate,
  IngestionCreatePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleIngestionsFetch({ payload }: SagaPayload<IngestionsFetchPayload>) {
  const state: StateUpdatePayload = { ingestions: null, pagination: undefined };
  try {
    const [ingestions, pagination] = (yield call(IngestionApi.getAll, payload)) as [Ingestion[], Pagination];
    state.ingestions = ingestions;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleIngestionCreate({ payload }: SagaPayload<IngestionCreatePayload>) {
  try {
    yield call(IngestionApi.create, payload);
    const ingestionsFetchPayload: IngestionsFetchPayload = { ingestableType: payload.ingestableType, ingestableId: payload.ingestableId, page: 1, perPage: 10 };
    yield put(ingestionsFetch(ingestionsFetchPayload));
  } catch { }
}

export default function* () {
  yield takeLatest(ingestionsFetch, handleIngestionsFetch);
  yield takeLatest(ingestionCreate, handleIngestionCreate);
}
